import { InteractionHistoryFiltersPopoverView } from "./InteractionHistoryFiltersPopoverView";
import { useEffect, useMemo } from "react";
import {
	HistoryFilterActions,
	HistoryFilterState,
} from "@/common/stores/nonpersistingStores/history/types";
import { useHistoryFilterStore } from "@/common/stores/nonpersistingStores/history/historyFilterStore";
import { AppCacheState, CacheKey, useAppCacheStore } from "@/common/stores/persistingStores/app";
import { InteractionHistoryFilter } from "./types";
import { FilterButton } from "@/components/molecules/filterbutton";

export const InteractionHistoryFiltersButton = () => {
	const cacheKey: CacheKey = CacheKey.HistoryFilter;

	const historyFilterState = useHistoryFilterStore(
		(state: HistoryFilterState) => state
	);

	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);

	const historyFilterActions = useHistoryFilterStore(
		(actions: HistoryFilterActions) => actions
	);

	useEffect(() => {
		const filterCache = appStoreCache[cacheKey] as InteractionHistoryFilter;
		historyFilterActions.setFilterData(filterCache);
	}, [appStoreCache, historyFilterActions.setFilterData]);

	const filterNumber = useMemo(() => {
		const filterData = historyFilterState.filterData;

		return (
			(filterData?.handling?.length || 0) +
			(filterData?.miscellaneous?.length || 0) +
			(filterData?.types?.length || 0) + 
			(filterData?.showMyInteractions ? 1 : 0)
		);
	}, [historyFilterState.filterData]);

	return (
		<FilterButton
			filterNumber={filterNumber}
			content={<InteractionHistoryFiltersPopoverView />}
		/>
	);
};
